import dayjs from 'dayjs';
import { useCallback, useMemo } from 'react';

import { useUser } from '../../hooks/useUser';

import { parseDate } from '@utilities/dateTime';

export const useVideoLock = ({
  activateLogin,
  blockHighlights,
  publicationDate,
  videoKind,
  maxTimeAgo,
}: {
  activateLogin?: boolean;
  blockHighlights?: boolean;
  publicationDate?: string;
  videoKind?: string;
  maxTimeAgo?: number;
}) => {
  const { logged } = useUser();
  const checkDates = useCallback(() => {
    if (!publicationDate) return false;

    const now = dayjs(),
      eventDate = parseDate(publicationDate),
      diff = now.diff(eventDate, 'hour');
    return diff > maxTimeAgo;
  }, [maxTimeAgo, publicationDate]);

  return useMemo(() => {
    if (activateLogin) return !logged;

    const isLockedHighlight =
      blockHighlights &&
      (videoKind === 'Long Highlights' ||
        videoKind === 'Medium Highlights' ||
        (videoKind === 'Highlights' && checkDates()));

    if (isLockedHighlight) return !logged;

    return false;
  }, [activateLogin, blockHighlights, checkDates, logged, videoKind]);
};
